module.exports = __webpack_public_path__ + "static/media/logo_ue.6bcbf7b2.jpg";